import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import Discussion from "@/components/DiscussionForum/DiscussionForum.vue";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

import { client_domain } from "@/main.js";

export default {
    props: {
        is_public: {
            type: Boolean,
            default: false,
        },
        portal_admin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Discussion,
        Sidebar,
        Navbar,
        InactivityModal,
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        this.user_details = get_user_details();
        this.get_question_types();
        this.filter_surveys();

        this.fetchQuestions();

        if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
            this.soulcity_domain = true;
        }
    },

    data() {

        return ({
            selectedSurveyId: null,
            token_exists: false,
            surveys: [],
            activeVoiceTab: 'discussions',
            survey_name: '',
            survey_description: '',
            questions: [],
            showQuestionsForm: true,
            errors: [],
            answers: {},
            filteredQuestions: [],
            survey_survey_selectname: "",
            selectedQuestions: [],
            description: "",
            showQuestionForm: false,
            newQuestion: {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            },
            question_types: [],
            showSelectedQuestions: false,
            createdQuestions: [],
            survey_questions: [],
            portal_id: null,
            expandedQuestions: new Map(),
            allowMultiple: false,
            options: [
                { value: '' },
                { value: '' },
                { value: '' }
            ],
            selectedPoll: null,
            numberErrors: {},
            soulcity_domain: false,
            user_details: {
                "user_role": '',
                "user_id": '',
            },
            openOptions: new Map(),
            flipped_id: null,
            isEditMode: false,

        })
    },
    methods: {
    openCreateModal() {
      this.isEditMode = false;
    //   this.resetPortalForm();
      $('#create_survey').modal('show');
    },
    openEditModal(survey) {
      this.isEditMode = true;
      this.survey_name = survey.name;
      this.description = survey.description;
      $('#create_survey').modal('show');
    },
        getToken() {
            return get_token();
        },

        get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },

        filter_surveys() {
            const portal_id = Number(this.$route.params.portal_id);

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_survey/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({ portal_id }),
                success: (response) => {
                    this.surveys = response.data;
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },

        fetchQuestions() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
                method: "POST",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.questions = response.data.questions;
                },
            });
        },
        onQuestionInput(event) {
            const inputValue = event.target.value.toLowerCase();
            this.filteredQuestions = this.questions.filter((q) =>
                q && q.question && q.question.toLowerCase().includes(inputValue)
            );
        },
        onQuestionSelect(event) {
            const selectedValue = event.target.value;
            const selectedQuestion = this.questions.find(q =>
                q && q.question && q.question === selectedValue
            );

            if (selectedQuestion) {
                if (this.activeVoiceTab === 'polls') {
                    // For polls, directly fill in the form fields
                    this.newQuestion.text = selectedQuestion.question;
                    this.newQuestion.type = selectedQuestion.question_type.id;

                    // Properly format options with text property
                    if (selectedQuestion.options && selectedQuestion.options.length > 0) {
                        this.newQuestion.options = selectedQuestion.options.map(opt => ({
                            id: opt.id || Date.now() + Math.random(),
                            text: opt.option || opt.text || ''
                        }));
                    } else {
                        this.newQuestion.options = [];
                    }

                    this.newQuestion.is_mandatory = selectedQuestion.is_mandatory || false;
                    this.newQuestion.question_number = selectedQuestion.question_number || '';
                    this.filteredQuestions = [];
                } else {
                    this.selectQuestion(selectedQuestion);
                }
            }
        },

        selectQuestion(question) {
            if (!this.selectedQuestions.some(q => q.id === question.id)) {
                this.selectedQuestions.push(question);
            }

            this.newQuestion.text = question.question;
            this.newQuestion.type = question.question_type.id;
            this.newQuestion.options = question.options || [];
            this.newQuestion.is_mandatory = question.is_mandatory || false;
            this.newQuestion.question_number = question.question_number || '';

            if (!this.createdQuestions.some(q => q.id === question.id)) {
                this.createdQuestions.push({
                    text: question.question,
                    id: question.id,
                    type: question.question_type.id,
                    is_mandatory: question.is_mandatory || false,
                });
            }
            this.filteredQuestions = [];

            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };
        },
        validationforSurveyName() {
            this.errors = {};
            let valid = true;
            if (!this.survey_name || this.survey_name.trim() === '') {
                this.errors.survey_name = 'Survey name is required';
                valid = false;
            }
            return valid;
        },
        cancelEdit() {
            this.survey_id = null;
            this.survey_name = '';
            this.description = '';
            this.selectedQuestions = [];
            this.createdQuestions = [];
            if (this.$refs.quillSurveyEditorRef) {
                this.$refs.quillSurveyEditorRef.setHTML('');
            }

            // Switch back to surveys tab
            this.activeVoiceTab = 'surveys';
        },

        submitSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();
            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();

            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {
                this.addQuestionToSurvey()
                    .then(() => {
                        if (this.survey_id) {
                            this.updateSurvey();
                        } else {
                            this.group_surveys();
                        }
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }

            if (this.survey_id) {
                this.updateSurvey();
                return;
            }
            this.group_surveys();

        },

        updateSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();

            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();

            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.addQuestionToSurvey()
                    .then(() => {
                        this.update_survey_form();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.update_survey_form();
        },
        update_survey_form() {
            const payload = {
                survey_id: this.survey_id,
                name: this.survey_name,
                description: this.survey_description,
                questions: this.selectedQuestions.map(q => q.id),
            };

            Swal.fire({
                title: 'Updating survey...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_survey/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    this.filter_surveys();
                    Swal.fire({
                        icon: 'success',
                        title: 'Survey Updated',
                        text: 'Your survey has been successfully updated!',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        this.survey_id = null;
                        this.survey_name = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        if (this.$refs.quillSurveyEditorRef) {
                            this.$refs.quillSurveyEditorRef.setHTML('');
                        }

                        // Switch to surveys tab
                        this.activeVoiceTab = 'surveys';
                    });
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Edit Survey',
                        text: 'This survey has already been answered and cannot be edited.',
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }

            });
        },
        get_question_types() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                    this.question_types = response.data.question_types;
                },
            });
        },
        remove_created_question(index) {
            const removed = this.createdQuestions.splice(index, 1)[0];

            this.selectedQuestions = this.selectedQuestions.filter(q => q.id !== removed.id);
        },
        addQuestionToSurvey() {
            return new Promise((resolve, reject) => {
                if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Missing Information',
                        text: 'Please fill in all required fields for the question',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                    reject('Missing required fields');
                    return;
                }

                // Check if the question already exists
                const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
                if (existingQuestion) {
                    if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                        this.selectedQuestions.push(existingQuestion);
                        this.createdQuestions.push({
                            text: existingQuestion.question,
                            id: existingQuestion.id,
                            type: existingQuestion.question_type.id,
                            is_mandatory: existingQuestion.is_mandatory || false,
                        });
                    }
                    this.newQuestion = {
                        text: '',
                        question_number: '',
                        type: '',
                        options: [],
                        is_mandatory: false,
                    };

                    Swal.fire({
                        icon: 'success',
                        title: 'Question Added',
                        text: 'Existing question has been added to your survey',
                        showConfirmButton: false,
                        timer: 1500,
                        position: 'bottom-end',
                        toast: true
                    });

                    resolve();
                } else {
                    // Create a new question via API
                    const formData = new FormData();
                    formData.append('question', this.newQuestion.text);
                    formData.append('question_type', this.newQuestion.type);
                    formData.append('question_number', this.newQuestion.question_number);
                    formData.append('is_mandatory', this.newQuestion.is_mandatory);

                    // Add options if any
                    if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                        this.newQuestion.options.forEach(option => {
                            if (option.text && option.text.trim() !== "") {
                                formData.append('options', option.text.trim());
                            }
                        });
                    }

                    Swal.fire({
                        title: 'Creating question...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                        method: "POST",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: (response) => {
                            if (response.status === "success") {
                                const newQuestion = response.question_data;

                                // Add to selected questions
                                if (newQuestion && newQuestion.id) {
                                    this.selectedQuestions.push({
                                        id: newQuestion.id,
                                        question: newQuestion.question
                                    });

                                    // Add to created questions list for display
                                    this.createdQuestions.push({
                                        text: newQuestion.question,
                                        id: newQuestion.id,
                                        type: newQuestion.question_type.id,
                                        is_mandatory: newQuestion.is_mandatory || false,
                                    });

                                    // Show success message
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Question Created',
                                        text: 'New question has been created and added to your survey',
                                        showConfirmButton: false,
                                        timer: 1500,
                                        position: 'bottom-end',
                                        toast: true
                                    });

                                    // Reset the form for the next question
                                    this.newQuestion = {
                                        text: '',
                                        question_number: '',
                                        type: '',
                                        options: [],
                                        is_mandatory: false,
                                    };

                                    // Refresh questions list
                                    this.fetchQuestions();

                                    // Resolve the promise with the new question
                                    resolve(newQuestion);
                                } else {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Question Created',
                                        text: 'Question was created but could not be added to survey. Please try again.',
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000,
                                        toast: true
                                    });
                                    reject('Question created but missing ID');
                                }
                            } else {
                                reject('Failed to create question');
                            }
                        },
                        error: () => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Failed to create question on survey.',
                                showConfirmButton: false,
                                timer: 1500,
                                position: 'bottom-end',
                                toast: true
                            });
                            reject('Failed to create question');
                        }
                    });
                }
            });
        },
        addOption() {
            if (!Array.isArray(this.newQuestion.options)) {
                this.newQuestion.options = [];
            }

            const newOption = { id: Date.now(), text: '' };
            this.newQuestion.options.push(newOption);
        },
        removeOption(index) {
            this.newQuestion.options.splice(index, 1);
        },
        deleteSurvey(survey_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_survey/`,
                        data: JSON.stringify({ survey_id: survey_id }),
                        headers: {
                            'Authorization': `Token ${this.getToken()}`,
                            'Content-Type': 'application/json'
                        },
                        success: (response) => {
                            const status = response.status;
                            if (status === "success") {
                                this.surveys = this.surveys.filter(survey => survey.id !== survey_id);
                                Swal.fire({
                                    title: 'Deleted!',
                                    text: 'The survey has been deleted.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1000,
                                    position: 'bottom-end',
                                    toast: true
                                })
                            } else {
                                Swal.fire({
                                  title: 'Failed!',
                                  text: response.message || 'An error occurred. Please try again.',
                                  icon: 'error',
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            Swal.fire({
                              title: 'Failed!',
                              text: xhr.responseJSON?.message || 'An error occurred. Please try again.',
                              icon: 'error',
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    });
                }
            });
        },



    }
};